<template>
  <DatePicker
    v-model="datePickerInput"
    @selected="dateSelected"
    :format="'yyyy-MM-dd'"
    :disabled-dates="{ customPredictor: predictDisabledDates }"
  />
</template>

<script>
import DatePicker from '@sum.cumo/vue-datepicker'
import '@sum.cumo/vue-datepicker/dist/Datepicker.css'
import { timeHelpers } from "../../helpers/timeHelpers";

export default {
  components: { DatePicker },
  props: {
    value: {
      type: String,
      default() {
        return '';
      }
    },
    restrictedBeforeDate: {
      type: [String, Boolean],
      default() {
        return false;
      }
    }
  },
  watch: {
    value () {
      this.syncValueAndModel();
    }
  },
  mounted() {
    this.syncValueAndModel();
  },
  computed: {
    _restrictedBeforeDate() {
      if (this.restrictedBeforeDate) {
        return new Date(timeHelpers.fromDateFormat(this.restrictedBeforeDate))
      }
      return false;
    }
  },
  data() {
    return {
      datePickerInput: ''
    }
  },
  name: "LabAdminDateRangePicker",
  methods: {
    syncValueAndModel() {
      if (!this.value) {
        return;
      }

      this.datePickerInput = new Date(`${this.value}T13:00:00`);
    },
    predictDisabledDates(date) {
      if (! this._restrictedBeforeDate) {
        return false;
      }

      return this._restrictedBeforeDate > date;
    },
    dateSelected(date) {
      this.datePickerInput = date;
      this.$emit('input', date ? this.$moment(date, this.$moment.defaultFormat).format("YYYY-MM-DD") : '');
    }
  }
}
</script>

<style scoped>

</style>
